import { useEffect, useState } from "react";
import { NotificationDiv } from "../SidebarNotificationsStyles";
import { ISenasaNotification } from "./model";

const SenasaNotificationCard = (props: {
  notification: ISenasaNotification;
}) => {
  const { notification } = props;
  const { dam } = notification;

  const [volantes, setVolantes] = useState<string>("");
  useEffect(() => {
    const volatesSlice = dam.volante_details
      .slice(0, 4)
      .map((v) => v.volante_num)
      .join(",");
    const volanteSilicePoint = dam.volante_details
      .map((v) => v.volante_num)
      .join(",");
    if (dam.volante_details.length < 4) {
      setVolantes(volanteSilicePoint);
    } else {
      setVolantes(volatesSlice);
    }
  }, [dam]);
  return (
    <div>
      <NotificationDiv
        fontWeight={500}
        fontSize="1.1rem"
        marginTop="0.5rem"
        color="#2E353D"
        paddingLeft="1rem"
      >
        Nº DAM: <b>{dam.dam_num}</b>
      </NotificationDiv>
      <div style={{ display: "flex" }}>
        <NotificationDiv
          fontWeight={500}
          fontSize="1.1rem"
          marginTop="0.5rem"
          color="#2E353D"
          paddingBottom="1rem"
          paddingLeft="1rem"
        >
          Nº VOLANTE{dam.volante_details.length > 1 && "S"}:{" "}
          <b>
            {`${
              dam.volante_details.length < 4 ? `${volantes}` : `${volantes}...`
            }`}
          </b>
        </NotificationDiv>
      </div>
    </div>
  );
};

export default SenasaNotificationCard;
